import StaffRepository from './staffRepository';
import DepartmentsRepository from './departmentsRepository';
import PermissionsRepository from './PermissionsRepository';
import RolesRepository from './RolesRepository';
import SupplierRepository from './supplierRepository';
import supplierManufactureRepository from './supplierManufactureRepository';
import supplierRawMaterialRepository from './supplierRawMaterialRepository';
import FormulationsRepository from './FormulationsRepository';
import customerRepository from './customerRepository';
import inventoryRepository from './inventoryRepository';
import sundrySupplierRepository from './sundrySupplierRepository';
import HolidayRepository from './HolidayRepository';
import activityLogRepository from './activityLogRepository';
import ManufacturingRepository from './ManufacturingRepository';
import SettingsRepository from './SettingsRepository';
import courierRepository from './courierRepository';
import otherSupplierRepository from './OtherSupplierRepository';
import IncotermRepository from './IncotermRepository';
import GlobalRepository from './GlobalRepository';
import sageRepository from "@/repository/sageRepository";
import CarrierRepository from "@/repository/CarrierRepository";
import TaxRepository from "@/repository/TaxRepository";
import ProductionCodeRepository from "@/repository/ProductionCodeRepository";
import CcpRepository from "@/repository/CcpRepository";
import ReportingRepository from "@/repository/ReportingRepository";
import UlRepository from "@/repository/UlRepository";
import InvoiceRepository from "@/repository/InvoiceRepository";
import FileRepository from "@/repository/FileRepository";
import NotificationsRepository from "@/repository/NotificationsRepository";
import TasksRepository from "@/repository/TasksRepository";
import BankAccountRepository from "@/repository/BankAccountRepository";
import ForeCastRepository from "@/repository/ForeCastRepository";
import BudgetToolRepository from "@/repository/BudgetToolRepository";
import IndustrialSectorsRepository from "@/repository/IndustrialSectorsRepository";
import RegionsRepository from "@/repository/RegionsRepository";
import SageSettingsRepository from "@/repository/SageSettingsRepository";
import SageSupplierTypeRepository from "@/repository/SageSupplierTypeRepository";
import DropDownRepository from "@/repository/DropDownRepository";
import ShortcutRepository from "@/repository/ShortcutRepository"
import PackSizeRepository from "@/repository/PackSizeRepository"
import FinancialRepository from '@/repository/FinancialRepository';
import CrmRepository from '@/repository/CrmRepository';
import CustomerSourceRepository from '@/repository/CustomerSourceRepository';
import CustomerUserTypeRepository from '@/repository/CustomerUserTypeRepository';
import MarginCostRepository from '@/repository/MarginCostRepository'
import ShippingCostRepository from '@/repository/ShippingCostRepository'
import SundryCostRepository from '@/repository/SundryCostRepository'
import AdditionalCostRepository from '@/repository/AdditionalCostRepository'
import PricingTierRepository from '@/repository/PricingTierRepository'
import ScheduledTasksRepository from "@/repository/ScheduledTasksRepository";
import LeaveRepository from '@/repository/LeaveRepository';
import CompanyScheduleRepository from '@/repository/CompanyScheduleRepository';
import DocumentTemplateRepository from '@/repository/DocumentTemplateRepository';
import TriangleTestRepository from '@/repository/TriangleTestRepository';
import SkillQualificationRepository from '@/repository/SkillQualificationRepository'
import DHLRepository from '@/repository/DHLRepository'
import RawMateralSettingsRepository from '@/repository/RawMateralSettingsRepository'
import SprayDryCost from '@/repository/SprayDryCost';
import AiChatRepository from '@/repository/AiChatRepository';
import ECDSettingsRepository from '@/repository/ECDSettingsRepository';
import SalesOrderLeadTimeRepository from '@/repository/SalesOrderLeadTimeRepository';
import OtifTargetRepository from '@/repository/OtifTargetRepository';
import CompanyAddressRepository from '@/repository/CompanyAddressRepository';

const repositories = {
  staff : StaffRepository,
  departments : DepartmentsRepository,
  permissions : PermissionsRepository,
  roles : RolesRepository,
  supplier : SupplierRepository,
  supplierManufacture : supplierManufactureRepository,
  supplierRawMaterial: supplierRawMaterialRepository,
  formulations: FormulationsRepository,
  customer: customerRepository,
  inventory: inventoryRepository,
  sundry: sundrySupplierRepository,
  holiday: HolidayRepository,
  incoterm: IncotermRepository,
  activity: activityLogRepository,
  manufacturing: ManufacturingRepository,
  settings: SettingsRepository,
  courier: courierRepository,
  other_supplier: otherSupplierRepository,
  global: GlobalRepository,
  sage: sageRepository,
  carrier: CarrierRepository,
  tax: TaxRepository,
  production_code: ProductionCodeRepository,
  ccp: CcpRepository,
  reporting: ReportingRepository,
  ul: UlRepository,
  invoice: InvoiceRepository,
  file: FileRepository,
  notification: NotificationsRepository,
  tasks: TasksRepository,
  bank_account: BankAccountRepository,
  forecast: ForeCastRepository,
  budget_tool: BudgetToolRepository,
  industrial_sector: IndustrialSectorsRepository,
  regions: RegionsRepository,
  sage_settings: SageSettingsRepository,
  sage_supplier_type: SageSupplierTypeRepository,
  drop_down: DropDownRepository,
  shortcuts: ShortcutRepository,
  pack_size: PackSizeRepository,
  financial: FinancialRepository,
  crm: CrmRepository,
  customer_source: CustomerSourceRepository,
  customer_user_type: CustomerUserTypeRepository,
  margin_cost: MarginCostRepository,
  shipping_cost: ShippingCostRepository,
  sundry_cost: SundryCostRepository,
  additional_cost: AdditionalCostRepository,
  pricing_tier: PricingTierRepository,
  scheduled_tasks:ScheduledTasksRepository,
  leave: LeaveRepository,
  company_schedule: CompanyScheduleRepository,
  document_template: DocumentTemplateRepository,
  triangle_tests: TriangleTestRepository,
  skills: SkillQualificationRepository,
  dhl: DHLRepository,
  rm_settings: RawMateralSettingsRepository,
  spray_dry_cost: SprayDryCost,
  ai_chat: AiChatRepository,
  ecd_settings: ECDSettingsRepository,
  so_lead_time: SalesOrderLeadTimeRepository,
  sales_order_lead_time: SalesOrderLeadTimeRepository,
  otif_target: OtifTargetRepository,
  otifTarget: OtifTargetRepository,
  company_address: CompanyAddressRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
